import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

/**
 * Hard lock for restoration-required memberships.
 * Source of truth (for now): localStorage "__membership_context"
 * Later (Phase C): replace/augment with backend verification status.
 */
export const membershipLockGuard: CanActivateFn = () => {
    const router = inject(Router);

    const token = localStorage.getItem('auth_token');
    if (!token) {
        router.navigate(['/member/login']);
        return false;
    }

    const raw = localStorage.getItem('__membership_context');
    if (!raw) return true; // if not present, do not block

    try {
        const ctx = JSON.parse(raw) as { restorationRequired?: boolean };
        if (ctx?.restorationRequired) {
            router.navigate(['/member/restoration']);
            return false;
        }
    } catch {
        // ignore parse errors (do not block)
    }

    return true;
};
